import axios from 'axios';
import * as URLS from '@/config/urls';
import { AUTHORIZE_NET } from '@/config/config';
import * as codeBy from "@/methods/getCodeByState";
import store from "@/store";

const url = 'https://junkit.vonigo.com/api/v1/data/'

const urlApi = 'https://junkit.vonigo.com/api/v1/'


export const applePayAuthorize = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = URLS.AUTHORIZE_PAYMENT;

		const requestData = {
			createTransactionRequest: {
				merchantAuthentication: {
					name: AUTHORIZE_NET.login,
					transactionKey: AUTHORIZE_NET.transactionKey,
				},
				transactionRequest: {
					transactionType: 'authCaptureTransaction',
					amount: data.amount,
					payment: {
						opaqueData: {
							dataDescriptor: "COMMON.APPLE.INAPP.PAYMENT",
							dataValue: "" // токен Apple Pay JSON или base64
						}
					},
					lineItems: {
						lineItem: {
							itemId: '1',
							name: data.serviceName,
							description: data.serviceName,
							quantity: '1',
							unitPrice: data.amount,
						},
					},
				},
			},
		};

		axios
			.post(queryUrl, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err);
			});
	});
}


export const createCustomerProfileAuthorize = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = URLS.AUTHORIZE_PAYMENT;

		const { clientId } = data;
		const today = new Date();
		const merchantCustomerId = `${today.getTime()}${clientId}`;
		const requestData = {
			createCustomerProfileRequest: {
				merchantAuthentication: {
					name: AUTHORIZE_NET.login,
					transactionKey: AUTHORIZE_NET.transactionKey,
				},
				profile: {
					merchantCustomerId,
					email: data.email,
					paymentProfiles: {
						customerType: 'individual',
						billTo: {
							firstName: data.firstName,
							lastName: data.lastName,
							address: data.address,
							city: data.city,
							state: data.state,
							zip: data.postalCode,
							country: store.getters.country,
							phoneNumber: data.phone,
						},
						payment: {
							creditCard: {
								cardNumber: data.cardNumber,
								// cardCode: data.cardCode,
								expirationDate: data.expirationDate,
							},
						},
					},
				},
				validationMode: AUTHORIZE_NET.validationMode,
			},
		};

		axios
			.post(queryUrl, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const updateCustomerPayProfileAuthorize = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = URLS.AUTHORIZE_PAYMENT;

		const requestData = {
			updateCustomerPaymentProfileRequest: {
				merchantAuthentication: {
					name: AUTHORIZE_NET.login,
					transactionKey: AUTHORIZE_NET.transactionKey,
				},
				customerProfileId: data.customerProfileId,
				paymentProfile: {
						customerType: 'individual',
						billTo: {
							firstName: data.firstName,
							lastName: data.lastName,
							address: data.address,
							city: data.city,
							state: data.state,
							zip: data.postalCode,
							country: store.getters.country,
							phoneNumber: data.phone,
						},
						payment: {
							creditCard: {
								cardNumber: data.cardNumber,
								// cardCode: data.cardCode,
								expirationDate: data.expirationDate,
							},
						},
						customerPaymentProfileId: data.customerPaymentProfileId
					},
			},
		};

		axios
			.post(queryUrl, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const updateCustomerProfileAuthorize = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = URLS.AUTHORIZE_PAYMENT;

		const requestData = {
			updateCustomerProfileRequest: {
				merchantAuthentication: {
					name: AUTHORIZE_NET.login,
					transactionKey: AUTHORIZE_NET.transactionKey,
				},
				profile: {
					merchantCustomerId: data.merchantCustomerId,
					email: data.email,
					customerProfileId: data.customerProfileId
				},
			},
		};

		axios
			.post(queryUrl, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const getCustomerProfileAuthorize = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = URLS.AUTHORIZE_PAYMENT;

		const requestData = {
			getCustomerProfileRequest: {
				merchantAuthentication: {
					name: AUTHORIZE_NET.login,
					transactionKey: AUTHORIZE_NET.transactionKey,
				},
				customerProfileId: data.customerProfileId,
				includeIssuerInfo: "true",
			},
		};

		axios
			.post(queryUrl, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const sendPaymentAuthorize = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = URLS.AUTHORIZE_PAYMENT;

		const requestData = {
			createTransactionRequest: {
				merchantAuthentication: {
					name: AUTHORIZE_NET.login,
					transactionKey: AUTHORIZE_NET.transactionKey,
				},
				transactionRequest: {
					// authOnlyTransaction, authCaptureTransaction
					transactionType: 'authCaptureTransaction',
					amount: data.amount,
					profile: {
						customerProfileId: data.customerProfileId,
						paymentProfile: { paymentProfileId: data.paymentProfileId },
					},
					lineItems: {
						lineItem: {
							itemId: '1',
							name: data.serviceName,
							description: data.serviceName,
							quantity: '1',
							unitPrice: data.amount,
						},
					},
				},
			},
		};

		axios
			.post(queryUrl, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const savePayment = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.PAYMENTS}`;

		const requestData = {
			securityToken: data.securityToken,
			method: 3,
			clientID: data.clientId,
			jobID: data.jobID,
			authNetClient: data.customerProfileId,
			authNetCard: data.paymentProfileId,
			authNetCardLast4Digits: data.cardNumber,
			authNetTransaction: data.transactionId,
			authNetTransactionLog: JSON.stringify(data.transactionResponse),
			Fields: [
				{
					fieldID: 930, // amount distributed (applied to an invoice)
					fieldValue: '$0',
				},
				{
					fieldID: 931, // payment amount
					fieldValue: data.amount.toString(),
				},
				{
					fieldID: 929,
					fieldValue: '', // check number
				},
				// {
				//   fieldID: 928, // payment notes
				//   fieldValue: data.notes,
				// },
				{
					fieldID: 936, // payment type
					optionID: 10124, // 10124 - Credit Card, 10118 - Cash
				},
			],
		};

		axios
			.post(queryUrl, encodeURIComponent(JSON.stringify(requestData)), {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const saveCreditCard = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.PAYMENTS}`;

		const requestData = {
			securityToken: data.securityToken,
			method: data.method,
			clientID: data.clientId,
			authNetClient: data.authNetClient,
			authNetCard: data.authNetCard,
			authNetCardLast4Digits: data.last4Digits,
			firstName: data.firstName,
			lastName: data.lastName,
			address: data.address,
			city: data.city,
			state: data.state,
			country: data.country,
			zipCode: data.postalCode,
		};
		if(data.cardID !== '') {
			//@ts-ignore
			requestData.cardID = data.cardID
		}
		axios
			.get(queryUrl, { params: requestData })
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});

}

export const getCreditCards = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.PAYMENTS}`;

		const requestData = {
			securityToken: data.securityToken,
			method: 16,
			clientID: data.clientId,
		};

		axios
			.get(queryUrl, { params: requestData })
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}



